import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastService } from '../../services/toast.service';
import {
  LogAnalyticsService,
  LogAnalyticsWorkspace,
  QueryResult
} from '../../services/log-analytics.service';

@Component({
  selector: 'app-log-analytics-query',
  templateUrl: './log-analytics-query.component.html',
  styleUrls: ['./log-analytics-query.component.scss'],
  standalone: false
})
export class LogAnalyticsQueryComponent implements OnInit {
  workspaces: LogAnalyticsWorkspace[] = [];
  queryForm: FormGroup;
  queryResult: QueryResult | null = null;
  isLoading = false;

  constructor(
    private readonly logAnalyticsService: LogAnalyticsService,
    private readonly fb: FormBuilder,
    private readonly toast: ToastService
  ) {
    this.queryForm = this.fb.group({
      workspace: [''],
      query: ['']
    });
  }

  ngOnInit(): void {
    this.loadWorkspaces();
  }

  private loadWorkspaces(): void {
    this.isLoading = true;
    this.logAnalyticsService.getWorkspaces().subscribe({
      next: (workspaces) => {
        this.workspaces = workspaces.value;
        this.isLoading = false;
      },
      error: (error) => {
        this.toast.error(`Error loading workspaces: ${error.message}`);
        this.isLoading = false;
      }
    });
  }

  onExecuteQuery(): void {
    if (!this.queryForm.valid) {
      return;
    }

    const { workspace, query } = this.queryForm.value;
    this.isLoading = true;

    this.logAnalyticsService.executeQuery(workspace, query).subscribe({
      next: (result) => {
        this.queryResult = result;
        this.isLoading = false;
      },
      error: (error) => {
        this.toast.error(`Error executing query: ${error.message}`);
        this.isLoading = false;
      }
    });
  }

  getColumnNames(): string[] {
    return this.queryResult?.tables[0].columns.map(c => c.name) || [];
  }
}
